/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { FindPartnerAccountsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useFindPartnerAccountsArgs, useFindPartnerAccountsSpec, useFindPartnerAccountsRealtime, useFindPartnerAccountsPagination } from '../specs/admin.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { FindPartnerAccountsRow } from '../openapi-types.gen.js';
export type { useFindPartnerAccountsArgs } from '../specs/admin.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useFindPartnerAccountsPaginationContract = useFindPartnerAccountsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useFindPartnerAccountsInfinite` — both
 * read/write the same `PagedData<FindPartnerAccountsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): query, limit.
 */
const _useFindPartnerAccounts = createListHook({
  spec: useFindPartnerAccountsSpec,
  realtime: useFindPartnerAccountsRealtime,
  entityKey: null,
  pagination: _useFindPartnerAccountsPaginationContract,
});
export const useFindPartnerAccounts = _useFindPartnerAccounts as (args: useFindPartnerAccountsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useFindPartnerAccounts>;


/**
 * Auto-infinite: same cache as `useFindPartnerAccounts`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useFindPartnerAccounts` for "Load more"
 * buttons / non-scroll UX.
 */
const _useFindPartnerAccountsInfinite = createListHook({
  spec: useFindPartnerAccountsSpec,
  realtime: useFindPartnerAccountsRealtime,
  entityKey: null,
  pagination: _useFindPartnerAccountsPaginationContract,
  autoLoadMore: true,
});
export const useFindPartnerAccountsInfinite = _useFindPartnerAccountsInfinite as (args: useFindPartnerAccountsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useFindPartnerAccountsInfinite>;


/**
 * Per-field subscription hook for the `useFindPartnerAccounts` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useFindPartnerAccountsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useFindPartnerAccountsField = createFieldHook<FindPartnerAccountsRow>('useFindPartnerAccountsField');

/**
 * Hover/intent prefetch companion for `useFindPartnerAccounts` (also covers
 * `useFindPartnerAccountsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetch_useFindPartnerAccounts();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetch_useFindPartnerAccounts = createPrefetchHook(useFindPartnerAccountsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useFindPartnerAccountsArgs>;
